import React from 'react';
// import RBPagination from 'react-bootstrap/Pagination'; Todo, It should able to import Pagination from react-bootstrap, but not working now.
import PropTypes from 'prop-types';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import styles from './pagination.module.scss';

const className = augmentClassName(styles);
const Pagination = ({ dividedArray, currentSection, currentPageNumber, handlePageChange }) => {
  return (
    <>
      {dividedArray?.length > 1 && currentSection?.length > 1 && (
        <>
          <div {...className('pagination-container')}>
            <ul {...className('pagination', 'pagination-sm')}>
              {dividedArray.map((chunk, index) => (
                <li
                  data-key={`${chunk.length}-${index}`}
                  key={`${chunk.length}-${index}`}
                  {...className('page-item', currentPageNumber - 1 === index && 'active')}
                >
                  <button {...className('page-link')} onClick={() => handlePageChange(index + 1)}>
                    {index + 1}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </>
  );
};

Pagination.defaultProps = {
  dividedArray: [],
  currentSection: [],
  currentPageNumber: 1
};

Pagination.propTypes = {
  dividedArray: PropTypes.array,
  currentSection: PropTypes.array,
  currentPageNumber: PropTypes.number,
  handlePageChange: PropTypes.func
};
export default Pagination;
